var map = {
	"./PoppinsLatin-Medium.ttf": 236,
	"./PoppinsLatin-Regular.ttf": 237,
	"./PoppinsLatin-SemiBold.ttf": 238,
	"./bootstrap-icons.woff": 239,
	"./bootstrap-icons.woff2": 240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 235;